'use strict';

import { DataModel, DataModelSource, DataModelProperty } from './data-model';
import { DataModelArray, DataModelMultiFragmentArray, DataModelObject, Relation, RelationCardinality, RelationsConfig } from './data-model-base-objects';
import { DataModelPropertyDirection, DataModelSourceDirection, DataModelTypes } from './enumerations';

import { DataModelCalculatedProperty, DataModelCalculatedPropertiesInfo, DataModelSystemProperty } from './data-model-calculated-property';
import { DataModelDescriptor, DataModelPropertyDescriptor, DataModelSourceDescriptor } from './data-model-descriptor';
import DataModelProfiler from './data-model-profiler';
import DataModelHelper from './data-model-helper';
import ExtendDeep from './extend-deep';

export const exports = {
	DataModel,
	DataModelSource,
	DataModelProperty,
	DataModelArray,
	DataModelObject,
	DataModelMultiFragmentArray,
	RelationsConfig,
	Relation,
	RelationCardinality,
	DataModelPropertyDirection,
	DataModelSourceDirection,
	DataModelTypes,
	DataModelCalculatedProperty,
	DataModelCalculatedPropertiesInfo,
	DataModelSystemProperty,
	DataModelDescriptor,
	DataModelSourceDescriptor,
	DataModelPropertyDescriptor,
	DataModelProfiler,
	DataModelHelper,
	ExtendDeep,
};

window.mx = window.mx || {};
window.mx.SolutionBuilderAgent = window.mx.SolutionBuilderAgent || {};
Object.keys(exports).forEach((key) => (window.mx.SolutionBuilderAgent[key] = exports[key]));
